import { css } from 'styled-system/css';
import { Container } from '../Container';
import { SheetsMockup } from '../featureMockups';
import { Reveal } from '../Reveal';
import { GoogleSheetsMark } from './GoogleSheetsMark';

export function GoogleSheetsSection() {
  return (
    <section
      id="sheets"
      aria-label="Use it in Google Sheets"
      className={css({
        paddingBlock: { base: '16', md: '32' },
        scrollMarginTop: '20',
      })}
    >
      <Container>
        <div
          className={css({
            display: 'grid',
            gridTemplateColumns: {
              base: '1fr',
              md: 'minmax(0, 2fr) minmax(0, 1fr)',
            },
            gap: { base: '10', md: '12', lg: '16' },
            alignItems: 'center',
          })}
        >
          <Reveal
            className={css({
              order: { base: 2, md: 1 },
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: { base: '240px', md: '480px' },
            })}
          >
            <div
              aria-hidden="true"
              className={css({
                position: 'absolute',
                inset: '-8% -6%',
                background:
                  'radial-gradient(ellipse 70% 60% at 50% 40%, rgba(139,92,246,0.16), rgba(70,174,191,0.08) 45%, transparent 70%)',
                pointerEvents: 'none',
              })}
            />
            <div
              aria-hidden="true"
              className={css({
                position: 'relative',
                width: '90%',
                height: '80%',
              })}
            >
              <SheetsMockup />
            </div>
          </Reveal>

          <Reveal
            delay={120}
            className={css({
              order: { base: 1, md: 2 },
            })}
          >
            <GoogleSheetsMark />
            <h2
              className={css({
                fontFamily: 'sans',
                fontWeight: 'bold',
                fontSize: { base: '2xl', md: '3xl' },
                letterSpacing: 'tight',
                lineHeight: 'tight',
                color: 'text.primary',
                maxWidth: '16ch',
              })}
            >
              Use it in Google Sheets
            </h2>
            <p
              className={css({
                fontSize: { base: 'sm', md: 'base' },
                lineHeight: 'relaxed',
                color: 'text.secondary',
                maxWidth: '38ch',
                marginTop: '4',
              })}
            >
              Invite Exis like any other collaborator. It will chat with you and
              make changes to your sheets.
            </p>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
